import { render, staticRenderFns } from "./CoachListItem.vue?vue&type=template&id=5719b412&scoped=true&lang=pug"
import script from "./CoachListItem.vue?vue&type=script&lang=js"
export * from "./CoachListItem.vue?vue&type=script&lang=js"
import style0 from "./CoachListItem.vue?vue&type=style&index=0&id=5719b412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5719b412",
  null
  
)

export default component.exports